import { useMutation } from '@apollo/client/react';
import { toast } from 'sonner';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { BackupMemberRoleEnum } from 'src/graphql/schema';
import { BackupMemberUpdateDocument } from 'src/graphql/actions/backupMembers/backupMemberUpdate.mutation';

import { roleOptions, roleOptionsDict } from '../model/roleOptions';
import { refetchBackupMembers } from '../api';

const RoleCell = ({ role, id, canUpdate }: { role: BackupMemberRoleEnum; id: string; canUpdate: boolean }) => {
  const [updateBackupMember] = useMutation(BackupMemberUpdateDocument);

  const onUpdate = async (role: BackupMemberRoleEnum) => {
    const { data } = await updateBackupMember({
      variables: {
        input: {
          backupMemberId: id,
          backupMemberParams: {
            role,
          },
        },
      },
    });

    if (data?.backupMemberUpdate?.success) {
      toast.success('Member access has been updated');
      refetchBackupMembers();
    } else {
      toast.error('Failed to update member access');
    }
  };

  if (canUpdate) {
    return (
      <Select value={role} onValueChange={onUpdate}>
        <SelectTrigger variant="ghost" justify="end" className="px-0">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {roleOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  return roleOptionsDict[role];
};

export default RoleCell;
